import { createInstance } from "@shuttlerock/i18n";
import de from "./de.yml";
import en from "./en.yml";
import ja from "./ja.yml";

export const { i18n, useTranslation } = createInstance({ en, de, ja }, "dataDisplay");

i18n.init();
